import { render, staticRenderFns } from "./veStuLiteraryAwardMy.vue?vue&type=template&id=a26206d0&scoped=true"
import script from "./veStuLiteraryAwardMy.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryAwardMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26206d0",
  null
  
)

export default component.exports